<script lang="ts" setup>
import type { SbStickyItems } from '@/types'
interface Props {
  blok: SbStickyItems
}
defineProps<Props>()
</script>

<template>
  <div class="sticky-items">
    <StoryblokComponent
      v-editable="blok"
      v-for="childBlok in blok.items"
      :key="childBlok._uid"
      :blok="childBlok"
      class="sticky-items__item"
    />
  </div>
</template>

<style scoped lang="scss">
.sticky-items {
  --card-gap: 24px;
  display: flex;
  flex-direction: column;
  gap: var(--card-gap);

  @media (min-width: $breakpoint-lg) {
    --card-gap: 50px;
  }

  &__item {
    @media (min-width: $breakpoint-lg) {
      position: sticky;
      top: 130px;

      @for $i from 1 through 6 {
        &:nth-child(#{$i}) {
          top: calc(130px + (var(--card-gap) * (#{$i})));
        }
      }
    }
  }
}
</style>
